const StorageEnums = {
  userData: 'userData',
  language: 'language',
  token: 'etcn',
};

export default StorageEnums;
